<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-06 18:44:36
 * @FilePath: \mrc-base-frontend\src\views\pushMessageTemplate\modules\langTemplate.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:30:12
-->
<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <v-card>
      <v-card-text class="tableBoxComponent">
        <v-form ref="btnForm">
          <v-row>
            <!-- title -->
            <v-col cols="12" sm="12" class="d-flex">
              <mrc_ess_multiText
                required
                style="width: 100%"
                :label="$t('label_The_title') + '*'"
                :readonly="disabled"
                :isNational="true"
                v-model="detailData.title"
                append-icon="mdi-longitude"
                :error-messages="$errors('detailData', 'title', requiredRule)"
              >
              </mrc_ess_multiText>
            </v-col>
            <v-col cols="12" sm="12" class="d-flex">
              <!-- 标题 -->
              <mrc_ess_multiText
                required
                style="width: 100%"
                :label="$t('label_Body') + '*'"
                :isNational="true"
                :readonly="disabled"
                v-model="detailData.body"
                :error-messages="$errors('detailData', 'body', requiredRule)"
              >
              </mrc_ess_multiText>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <template v-if="$store.state.uuid">
        <mrc_ess_submitBtn
          @cancel="cancel"
          :loading="loading"
          @success="success"
          v-if="!disabled"
        >
        </mrc_ess_submitBtn>
      </template>
      <template v-else>
        <mrc_ess_submitBtn
          @cancel="addcancel"
          :loading="commoninforloading"
          @success="addsuccess"
          :cancelText="$t('label_The_previous_step')"
        >
        </mrc_ess_submitBtn>
      </template>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>
<script>
import { required, between } from "vuelidate/lib/validators";
import {
  getLangTemplateList,
  updateLangTemplateDetail,
} from "@/service/api/pushLangTemplate";
export default {
  props: {
    commoninforloading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  validations: {
    detailData: {
      title: {
        required,
      },
      body: {
        required,
      },
    },
  },
  computed: {},
  watch: {},
  data() {
    return {
      detailData: {
        title: "", // 按钮名称
        body: "", // 按钮标题
      },
      uuid: "",
      skLoading: true,
      loading: false,
    };
  },
  async mounted() {
    this.skLoading = true;
    try {
      if (this.$store.state.uuid) {
        await this.getdetail();
        this.$router.replace({
          query: {
            temp: Date.now(), //必有
          },
        });
      } else {
      }
      this.skLoading = false;
    } catch (error) {
      this.skLoading = false;
    }
  },
  methods: {
    async getdetail() {
      this.skeletonloading = true;
      const res = await getLangTemplateList({
        template_uuid: this.$store.state.uuid,
      });
      if (res.code == 200) {
        this.detailData = Object.assign(this.detailData, res.data);
        this.skeletonloading = false;
      }
    },
    async cancel() {
      await this.getdetail();
      this.$emit("changeReadonly");
    },
    addcancel() {
      this.$emit("changee1", 1);
    },
    addsuccess() {
      this.$v.detailData.$touch();
      // 新增按钮提交
      if (this.$v.detailData.$error) return;
      this.$emit("submit", this.$clone(this.detailData));
    },
    async success() {
      //修改
      this.$v.detailData.$touch();
      if (this.$v.detailData.$error) return;
      this.loading = true;
      await updateLangTemplateDetail(
        Object.assign(this.detailData, {
          template_uuid: this.$store.state.uuid,
        })
      ).then((res) => {
        if (res.code == 200) {
          this.getdetail();
          this.$emit("changeReadonly");
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
        }
      });
      this.loading = false;
    },
  },
};
</script>